import { render, staticRenderFns } from "./wechat-tips.vue?vue&type=template&id=7eca0e19"
var script = {}
import style0 from "./wechat-tips.vue?vue&type=style&index=0&id=7eca0e19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports